import React from "react";
import { AssessmentInstrumentManagement } from "@components/AssessmentInstrument";

export default function AssessmentInstrumentIndex() {
  return <AssessmentInstrumentManagement />;
}
